import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { cn } from '@/lib/utils'

import { Checkbox } from '../ui/checkbox'
interface FormCheckboxProps {
  label: React.ReactNode
  name: string
  multiple?: boolean
  className?: string
  disabled?: boolean
  error?: any
  hideError?: boolean
}

export const FormCheckboxField = ({
  label,
  name,
  className,
  disabled = false,
  error,
  hideError = false,
}: FormCheckboxProps) => {
  const { control } = useFormContext()
  const checkboxId = `checkbox-${name}`

  return (
    <div className='flex flex-col gap-1'>
      <div className='flex gap-2 items-start'>
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <Checkbox
              {...field}
              id={checkboxId}
              checked={!!field.value}
              onCheckedChange={field.onChange}
              className={cn('w-6 h-6', className)}
              disabled={disabled}
              error={Boolean(error)}
            />
          )}
        />
        <label htmlFor={checkboxId} className={cn('cursor-pointer', disabled && 'opacity-50 cursor-not-allowed')}>
          {label}
        </label>
      </div>
      {error && !hideError && <p className='text-red-500 text-xs mt-1'>{error.message}</p>}
    </div>
  )
}
